import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
//@ts-ignore
import { isiOSDevice, isMobile } from "@utils/DeviceDetection";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
//@ts-ignore
import { getURLPage } from "@utils/URLPagesFactory";
/**
 * Requests for notification permission.
 * If given, then the given callback will be executed otherwise, throws an exception
 * */
export var requestPermissions = () => __awaiter(void 0, void 0, void 0, function* () {
  /*If mobile, then we will not use the notifications API for foreground push notifications */
  if (isiOSDevice()) return;
  var permission = yield Notification.requestPermission();
  if (permission === "granted") {
    return;
  } else throw new Error("Permission not granted");
});
export var createNotification = function createNotification(title, body) {
  var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var badge = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var urlToRedirect = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  if (isMobile()) throw new Error("We cannot use the Notification API to send push requests on mobile");
  var notification = new Notification(title, {
    body,
    icon,
    badge
  });
  notification.onclick = e => {
    sendGAEvent("push_notification_opened", {
      event_location: "Notifica Push - Android_or_Web"
    });
    /* Saving the analytics event */
    if (urlToRedirect) window.location.href = getURLPage(urlToRedirect);
  };
  return notification;
};
export var isNotificationGranted = () => {
  if (isiOSDevice()) return false;
  return Notification.permission === "granted";
};
export var isNotificationDenied = () => {
  if (isiOSDevice()) return true;
  return Notification.permission === "denied" || Notification.permission === "default";
};